
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use the actual Supabase project credentials
const SUPABASE_URL = "https://bdvwkygtrettvwiwbxbc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJkdndreWd0cmV0dHZ3aXdieGJjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5OTI5MDIsImV4cCI6MjA2MDU2ODkwMn0.mFs9t5fXXnvrQX0f74IgBd-pUTtrFD1deCl-nVmIC34";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage, // Use localStorage for session storage
    persistSession: true, // Persist session across browser tabs and sessions
    autoRefreshToken: true, // Automatically refresh tokens
    detectSessionInUrl: true, // Detect session from URL (e.g., for OAuth redirects)
    debug: import.meta.env.DEV, // Enable debug logging in development
  },
});
